export default __webpack_public_path__ + "media/images/mail/email-f2eb66b3cff350e67125154b4df27534.png";